(() => {
  const SIZE_PARAM = "filter.v.option.size";

  function getActiveSizes() {
    const qs = new URLSearchParams(window.location.search);
    return qs.getAll(SIZE_PARAM).filter(Boolean);
  }

  function getPerPage() {
    const container = document.getElementById("ProductGridContainer");
    const per = container?.dataset?.perPage;
    const n = parseInt(per || "0", 10);
    return Number.isFinite(n) && n > 0 ? n : 24;
  }

  function getGrid() {
    return document.getElementById("product-grid");
  }

  function countCards(grid) {
    if (!grid) return 0;
    return grid.querySelectorAll(".collection-product-card").length;
  }

  function buildPageUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.set("page", String(page));
    return url.toString();
  }

  async function fetchGridForPage(page) {
    const url = buildPageUrl(page);
    const res = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
    if (!res.ok) return null;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.getElementById("product-grid");
  }

  // --- Berlin load-more hidden inputs ---
  function getLoadMoreInputs() {
    return {
      nextUrl: document.querySelector("input[data-next-url]"),
      totalPages: document.querySelector("input[data-total-pages]"),
      currentPage: document.querySelector("input[data-current-page]"),
    };
  }

  function getInputValueInt(input, fallback) {
    const n = parseInt(input?.value || "", 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function setNextUrlInput(nextUrlInput, page) {
    if (!nextUrlInput) return;
    nextUrlInput.value = buildPageUrl(page);
  }

  async function fillGridIfNeeded() {
    const activeSizes = getActiveSizes();
    if (!activeSizes.length) return; // niente filtro taglia

    const grid = getGrid();
    if (!grid) return;

    const perPage = getPerPage();
    let cards = countCards(grid);
    if (cards >= perPage) return;

    const { nextUrl, totalPages, currentPage } = getLoadMoreInputs();

    // Preferisci i valori dagli input Berlin (sono quelli che usa load-more.js)
    let curr = getInputValueInt(currentPage, parseInt(grid.dataset.currentPage || "1", 10));
    const total = getInputValueInt(totalPages, parseInt(grid.dataset.totalPages || "1", 10));

    if (curr >= total) return;

    let lastFetched = curr;

    // Riempie fino a perPage prendendo pagine successive
    for (let page = curr + 1; page <= total && cards < perPage; page++) {
      const nextGrid = await fetchGridForPage(page);
      if (!nextGrid) break;

      const nextCards = Array.from(nextGrid.querySelectorAll(".collection-product-card"));
      if (!nextCards.length) break;

      for (const card of nextCards) {
        grid.appendChild(card);
        cards++;
        if (cards >= perPage) break;
      }

      lastFetched = page;
    }

    // Se abbiamo consumato pagine, aggiorna STATO (grid + input hidden)
    if (lastFetched > curr) {
      // aggiorna dataset (utile al debug e a eventuali altri script)
      grid.dataset.currentPage = String(lastFetched);
      grid.dataset.totalPages = String(total);

      // aggiorna input hidden (FONDAMENTALE per non far impazzire load-more.js)
      if (currentPage) currentPage.value = String(lastFetched);
      if (totalPages) totalPages.value = String(total);

      const nextPage = lastFetched + 1;
      if (nextPage <= total) {
        setNextUrlInput(nextUrl, nextPage);
      } else if (nextUrl) {
        // fine pagine: svuota next url così load-more.js non tenta di fetchare
        nextUrl.value = "";
      }
    }
  }

  // Esegui al primo load
  document.addEventListener("DOMContentLoaded", () => {
    fillGridIfNeeded().catch(() => {});
  });

  // Dopo aggiornamenti AJAX dei filtri (ProductGridContainer viene sostituito)
  document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("ProductGridContainer");
    if (!container) return;

    let t;
    const mo = new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => {
        fillGridIfNeeded().catch(() => {});
      }, 180);
    });

    mo.observe(container, { childList: true, subtree: true });
  });
})();
